export default __webpack_public_path__ + "static/media/undraw_medical-research_pze7.84bef3ce.svg";